/**
 * Created by Alex on 22-Mar-19. Modified by Matthieu 13-11-25
 */
import React from 'react';
import {Button,Modal,Form,Row,Col} from 'react-bootstrap'
import { toast } from "react-toastify";

import { serverService } from '../../../_services/server.service';
import i18n from "i18next";
import {Trans} from "react-i18next";


interface MyProps {
    selectedQuestion:any,
    onQuestionAdded(extra:string):any,
    show:boolean,
    onHide():any,
}

interface MyState {
    submitted: boolean,
    loading: boolean,
    error: string,
    formFields:any,
    selectedQuestion:any,
    selectedImage: File | null,
    imagePreviewUrl: string | null,
    showImageDisclaimer: boolean,
}

class ModalAddNewQuestion extends React.Component<MyProps,MyState> {

    constructor(props) {
        super(props);

        this.state = {
            submitted: false,
            loading: false,
            error: '',

            formFields:{},

            selectedQuestion: {},
            selectedImage: null,
            imagePreviewUrl: null,
            showImageDisclaimer: false,
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleImageClick = this.handleImageClick.bind(this);
        this.handleImageChange = this.handleImageChange.bind(this);
        this.handleRemoveImage = this.handleRemoveImage.bind(this);
        this.closeImageDisclaimer = this.closeImageDisclaimer.bind(this);
        this.handleDisclaimerAccept = this.handleDisclaimerAccept.bind(this);
    }

    componentDidMount(){
    }

    componentWillUnmount() {
        // Nettoyer l'URL de preview pour éviter les fuites mémoire
        if (this.state.imagePreviewUrl) {
            URL.revokeObjectURL(this.state.imagePreviewUrl);
        }
    }

    handleChange(e) {
        const { name, value } = e.target;
        let formFields = this.state.formFields;
        formFields[name] = value;
        this.setState({ formFields: formFields });
    }

    handleImageClick() {
        this.setState({ showImageDisclaimer: true });
    }

    closeImageDisclaimer() {
        this.setState({ showImageDisclaimer: false });
    }

    handleDisclaimerAccept() {
        this.setState({ showImageDisclaimer: false });
        // Déclencher l'input file
        const fileInput = document.getElementById('imageInput') as HTMLInputElement;
        if (fileInput) {
            fileInput.click();
        }
    }

    handleImageChange(e) {
        const file = e.target.files?.[0];
        if (!file) return;

        // Vérifier le format PNG
        if (file.type !== 'image/png') {
            toast.error('Format PNG uniquement');
            return;
        }

        // Valider dimensions et aspect ratio
        const img = new Image();
        const objectUrl = URL.createObjectURL(file);
        
        img.onload = () => {
            const width = img.width;
            const height = img.height;
            const ratio = width / height;

            // Vérifier dimensions minimales
            if (width < 2000 || height < 1200) {
                toast.error('Dimensions minimales : 2000 x 1200 px');
                URL.revokeObjectURL(objectUrl);
                return;
            }

            // Vérifier aspect ratio (1.6 à 1.8)
            if (ratio < 1.6 || ratio > 1.8) {
                toast.error('Ratio largeur/hauteur doit être entre 1.6 et 1.8');
                URL.revokeObjectURL(objectUrl);
                return;
            }

            // Tout est OK
            this.setState({
                selectedImage: file,
                imagePreviewUrl: objectUrl
            });
        };

        img.src = objectUrl;
    }

    handleRemoveImage() {
        if (this.state.imagePreviewUrl) {
            URL.revokeObjectURL(this.state.imagePreviewUrl);
        }
        this.setState({
            selectedImage: null,
            imagePreviewUrl: null
        });
    }

    handleSubmit(e) {
        e.preventDefault();

        this.setState({submitted: true});

        const { formFields, selectedImage } = this.state;
        const QuestionText = formFields.QuestionText;

        // stop here if form is invalid
        if (!(QuestionText)) {
            toast.error(i18n.t("trans_33_msg_missing_fields"));
            return;
        }

        // Bloquer si image présente mais texte vide
        if (selectedImage && !QuestionText.trim()) {
            toast.error("Le texte de la question ne peut pas être vide si vous ajoutez une image");
            return;
        }

        let userStr = localStorage.getItem('user');
        let IdCompany = 0;
        if(userStr) {
            let userObj = JSON.parse(userStr);
            IdCompany = userObj.IdCompany;
        }

        this.setState({submitted: true, loading: true});

        let question = {'IdQuestion': 0,'IdCompany':IdCompany.toString(), 'QuestionText':QuestionText };
        if(this.state.selectedQuestion && typeof(this.state.selectedQuestion.IdQuestion) !== "undefined"){
            question.IdQuestion = this.state.selectedQuestion.IdQuestion;

            serverService.updateQuestion(question)
                .then(
                    result => {
                        this.setState({submitted: false, loading: false});
                        if(result.status == 1){
                            let messageStr = i18n.t("trans_33_msg_question_edited");
                            toast.success(messageStr);
                            this.props.onQuestionAdded(result.extra);
                        } else {
                            toast.error(i18n.t("trans_33_msg_question_edit_failed"));
                        }
                    },
                    error => {
                        toast.warn("Did not update question");
                        this.setState({ loading: false });
                    }
                );
        } else {
            serverService.insertQuestion(question)
                .then(
                    result => {
                        this.setState({submitted: false, loading: false});
                        if(result.status == 1){
                            let messageStr = i18n.t("trans_33_msg_question_added");
                            toast.success(messageStr);
                            this.props.onQuestionAdded(result.extra);
                        } else {
                            toast.error(i18n.t("trans_33_msg_question_add_failed"));
                        }
                    },
                    error => {
                        toast.warn("Did not insert question");
                        this.setState({ loading: false });
                    }
                );
        }
    }

    componentDidUpdate(prevProps, prevState){
        if(this.props.selectedQuestion !== prevState.selectedQuestion){
            // Nettoyer l'ancienne preview si elle existe
            if (this.state.imagePreviewUrl) {
                URL.revokeObjectURL(this.state.imagePreviewUrl);
            }

            this.setState({
                selectedQuestion:this.props.selectedQuestion,
                selectedImage: null,
                imagePreviewUrl: null,
                showImageDisclaimer: false,
            });

            let formFields = this.state.formFields;
            formFields.QuestionText = "";

            if(this.state.selectedQuestion && typeof(this.state.selectedQuestion.IdQuestion) !== "undefined"){
                formFields.QuestionText = this.props.selectedQuestion.QuestionText;
                // TODO: Si la question a déjà une image, charger la preview depuis image_path
            }

            this.setState({formFields:formFields});
        }
    }


    render() {
        let {loading} = this.state;

        let titleStr = i18n.t("trans_33_modal_add_question_add");
        if(this.state.selectedQuestion && typeof(this.state.selectedQuestion.IdQuestion) !== "undefined"){
            titleStr = i18n.t("trans_33_modal_add_question_edit");
        }

        let confirmButtonStr = i18n.t("trans_33_modal_add_question_add");
        if(this.state.selectedQuestion && typeof(this.state.selectedQuestion.IdQuestion) !== "undefined"){
            confirmButtonStr = i18n.t("trans_33_save");
        }

        return (
            <Modal
                show={this.props.show}
                onHide={this.props.onHide}
                dialogClassName="modal-90w"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton translate="yes">
                    <Modal.Title id="example-custom-modal-styling-title">
                        {titleStr}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={this.handleSubmit}>

                        <Form.Group controlId="formBasicName">
                            <Form.Label>
                                *<Trans>trans_33_modal_add_question_question_text</Trans>
                            </Form.Label>
                            <Form.Control size="sm" type="text" placeholder={i18n.t("trans_33_modal_add_question_type_in_the_question")}
                                          name="QuestionText"
                                          value={this.state.formFields.QuestionText}
                                          onChange={this.handleChange}
                            />
                        </Form.Group>

                        <br/>

                        {/* Section Image */}
                        <Form.Group>
                            <Form.Label>Image (optionnelle)</Form.Label>
                            <div>
                                <input
                                    type="file"
                                    accept="image/png"
                                    onChange={this.handleImageChange}
                                    style={{ display: 'none' }}
                                    id="imageInput"
                                />
                                <Button 
                                    variant="secondary" 
                                    size="sm"
                                    onClick={this.handleImageClick}
                                >
                                    📷 Ajouter une image
                                </Button>
                                
                                {this.state.imagePreviewUrl && (
                                    <div style={{ marginTop: '10px' }}>
                                        <img 
                                            src={this.state.imagePreviewUrl} 
                                            alt="Preview" 
                                            style={{ maxWidth: '300px', maxHeight: '200px', border: '1px solid #ddd', borderRadius: '4px' }}
                                        />
                                        <br/>
                                        <Button 
                                            variant="danger" 
                                            size="sm" 
                                            onClick={this.handleRemoveImage}
                                            style={{ marginTop: '5px' }}
                                        >
                                            ❌ Supprimer l'image
                                        </Button>
                                    </div>
                                )}
                            </div>
                        </Form.Group>

                        <br/>

                        <Button variant="primary" type="submit" disabled={loading}>
                            {confirmButtonStr}
                        </Button>
                        {loading &&
                        <img alt="loading" src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
                        }
                    </Form>
                </Modal.Body>
                <br/>

                {/* Modale Disclaimer Image */}
                <Modal
                    show={this.state.showImageDisclaimer}
                    onHide={this.closeImageDisclaimer}
                    centered
                >
                    <Modal.Header closeButton>
                        <Modal.Title>⚠️ Important - Image pour la question</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <p><strong>Avant d'ajouter une image, veuillez noter :</strong></p>
                        <ul>
                            <li>Le <strong>texte sur l'image</strong> doit correspondre au <strong>texte de la question</strong></li>
                            <li>Le <strong>champ texte de la question ne peut pas être vide</strong></li>
                            <li>Dimensions minimales : <strong>2000 x 1200 px</strong></li>
                            <li>Ratio largeur/hauteur : <strong>entre 1.6 et 1.8</strong></li>
                            <li>Format : <strong>PNG uniquement</strong></li>
                        </ul>
                        <p>💡 <strong>Astuce :</strong> Créez votre image dans PowerPoint (exporte en 4000x2250, idéal !)</p>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={this.closeImageDisclaimer}>
                            Annuler
                        </Button>
                        <Button variant="primary" onClick={this.handleDisclaimerAccept}>
                            Compris, choisir une image
                        </Button>
                    </Modal.Footer>
                </Modal>
            </Modal>
        );
    }

}

export default ModalAddNewQuestion;